export default __webpack_public_path__ + "static/media/newblog-head.ac7835c5.jpg";